/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("UtilizationTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return UtilizationTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<UtilizationTypeQueryOperator>): UtilizationTypeQueryOperator {
        let obj = Object.assign(new UtilizationTypeQueryOperator(), model);
        UtilizationTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationTypeQueryOperator>): UtilizationTypeQueryOperator {
        if (!model) return null;
        return UtilizationTypeQueryOperator.newInstance(<UtilizationTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationTypeQueryOperator) {
        if (!obj) return;

        models.UtilizationTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UtilizationTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Utilization types to include
     */
    utilization_types: Array<string>;

}
